import { flags } from '../../common/constants/flags';
import * as Sentry from '@sentry/browser';
import React, { Component } from 'react';
import Moment from 'moment';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Header from '../../components/Header';
import styles from './CoreLayout.scss';
import '../../styles/core.scss';
import version from '../../version.json';
import { ConfigureFlopFlip, ToggleFeature } from '@flopflip/react-redux';
import adapter from '@flopflip/launchdarkly-adapter';
import config from '../../../config';

import AuthHOC from '../../common/HOC/AuthHOC';
import LeftSidebar from '../../components/Sidebar/Sidebar';
import { Notification } from '../../common/components/Notification';
import { hideNotification } from '../../store/app';
import CancelButtonWithModal from '../../common/components/ConfirmCancelModal/ConfirmCancelModal';

const enableLogger = () => {
  if (
    config.environment === 'prod' ||
    config.environment === 'prod0' ||
    config.environment === 'stage'
  ) {
    Sentry.init({
      dsn: config.sentryDSN,
      environment: config.environment,
    });
  }
};

const CoreContent = AuthHOC(
  ({ children, app, hideNotification, location, idleStatus }) => {
    const copyright = `© 2011-${Moment().format(
      'YYYY'
    )} AXS. All rights reserved.`;
    const modalContent =
      'You’ll be logged out in two minutes if you don’t resume your session.';

    return (
      <ConfigureFlopFlip
        adapter={adapter}
        adapterArgs={{
          clientSideId: config.ldId,
          user: { key: app.contextId },
        }}
      >
        <div>
          <ToggleFeature flag={flags.LOGGER}>
            {() => {
              enableLogger();
              return null;
            }}
          </ToggleFeature>
          <Notification
            active={app.notification.message}
            message={app.notification.message}
            type={app.notification.status}
            dismissable={app.notification.dismissable}
            id="notification"
            hideNotification={hideNotification}
          />
          <Header />
          <LeftSidebar
            contextId={app.contextId}
            contexts={app.contexts}
            location={location}
          />
          <div className={styles['viewport']}>{children}</div>
          <div
            id="site-footer"
            className={`test-site-footer-container ${styles['footer']}`}
          >
            <span className="test-site-footer-text">
              {copyright} Version{' '}
              <span className="test-footer-version">{version.version}</span>
            </span>
          </div>
          <CancelButtonWithModal
            openModal={idleStatus === 'AWAY'}
            cancelButtonLabel="Continue"
            confirmButtonLabel="Logout"
            headerCopy="Still there?"
            contentCopy={modalContent}
            cancelTestClasses="test-session-idle-cancel-button"
            confirmTestClasses="test-session-idle-confirm-button"
            handleAction={() => {}}
            headerTestClasses="test-session-idle-header"
            modalTestClasses="test-session-idle"
            modalContentTestClasses="test-session-idle-content"
            disabled={false}
            modalButtonSize="medium"
            hideActions={true}
          />
        </div>
      </ConfigureFlopFlip>
    );
  }
);

export class CoreLayout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      messagesVisible: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.app.notification !== nextProps.app.notification) {
      this.setState({
        messagesVisible: true,
      });
    }
  }

  render() {
    const children = this.props.children;
    const layoutStyles = { width: '100%', height: '100%', display: 'flex' };

    return (
      <div>
        {window.location.pathname.includes('/login') ? (
          <div style={layoutStyles}>{children}</div>
        ) : (
          <CoreContent
            ref={(CoreContent) => (this.mainContainer = CoreContent)}
            showMessages={this.state.messagesVisible}
            {...this.props}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    hideNotification: () => dispatch(hideNotification()),
  };
};

const mapStateToProps = (state) => {
  return {
    app: state.app,
    idleStatus: state.idle.idleStatus,
  };
};

CoreLayout.propTypes = {
  app: PropTypes.object,
  children: PropTypes.element.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CoreLayout);



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/CoreLayout.js